/**
 * The component has the option to use the constellation ModalDialog componennt
 * This update is not meant to be perminate.
 *
 * If you want to use this component
 * set the prop useModalDialog to be true
 *    useModalDialog = true
 *
 * The constellation component has a different api
 * I am leaving props that are being passed for now because
 * I am not sure of the unintended consequences
 *
 * Once all of the modals have cleaned up all required props
 * we can depricate the MUI Modal component
 */

// TODO: remove unnessesary passed props and refactor implementations

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { DialogBody, Heading } from '@zillow/constellation';

import Modal from '@zg-rentals/multibrand-ui/lib/Modal';
import Modals from 'app/shared/components/Modal';
import ModalActions from 'app/shared/actions/ModalActions';
import ModalSelectors from 'app/shared/selectors/ModalSelectors';

import { StyledModalDialog } from './StyledComponents';

class ModalContainer extends React.Component {
    componentDidUpdate(prevProps) {
        if (this.props.isOpen && this.props.modalType !== prevProps.modalType) {
            prevProps.onClose();
            this.props.onOpen();
        }
    }

    handleClose = () => {
        this.props.onClose();
        this.props.dispatch(ModalActions.hideModal());
    };

    render() {
        const {
            className,
            dispatch,
            footer,
            header,
            hideBackButton,
            hideCloseButton,
            isFluid,
            isOpen,
            isWizard,
            modalType,
            onClickBack,
            parentSelector,
            shouldCloseOnOverlayClick,
            useModalDialog,
            ...modalProps
        } = this.props;

        const ModalContent = Modals[modalType];

        /**
         * When trying to set prop portal={parentSelector}
         * MESSAGE: Uncaught Invariant Violation: Target container is not a DOM element.
         */
        // TODO: fix parentSelector so we can use portal
        const renderModalDialog = () => (
            <StyledModalDialog
                // passed props that might be able to be removed
                isOpen={isOpen}
                id={parentSelector}
                onClickBack={onClickBack}
                hideBackButton={hideBackButton}
                hideCloseButton={hideCloseButton}
                isWizard={isWizard}
                // constellation props
                className={className}
                header={
                    <Heading level={6}>{header}</Heading>
                }
                shouldCloseOnOutsideClick={shouldCloseOnOverlayClick}
                scrollDocument={false}
                wide={true}
                onClose={this.handleClose}
                footer={footer && (
                    <div className="ModalDialog-Footer-Container">
                        {footer()}
                    </div>
                )}
                // style props
                isFluid={isFluid}
            >
                <DialogBody>
                    {ModalContent && <ModalContent {...modalProps} dispatch={dispatch} />}
                </DialogBody>
            </StyledModalDialog>
        );

        const renderModal = () => (
            <Modal
                className={className}
                header={header}
                isOpen={isOpen}
                id={parentSelector}
                shouldBypassBodyStyling={true}
                onRequestClose={this.handleClose}
                onClickBack={onClickBack}
                hideBackButton={hideBackButton}
                hideCloseButton={hideCloseButton}
                shouldCloseOnOverlayClick={shouldCloseOnOverlayClick}
                isWizard={isWizard}
            >
                {ModalContent && <ModalContent {...modalProps} dispatch={dispatch} />}
            </Modal>
        );

        return useModalDialog ? renderModalDialog() : renderModal();
    }
}

ModalContainer.defaultProps = {
    className: '',
    footer: null,
    header: '',
    isFluid: false,
    onClickBack: () => {},
    useModalDialog: false,
};

ModalContainer.propTypes = {
    className: PropTypes.string,
    dispatch: PropTypes.func.isRequired,
    footer: PropTypes.func,
    header: PropTypes.string,
    hideBackButton: PropTypes.bool.isRequired,
    hideCloseButton: PropTypes.bool.isRequired,
    isFluid: PropTypes.bool,
    isOpen: PropTypes.bool.isRequired,
    isWizard: PropTypes.bool.isRequired,
    modalType: PropTypes.oneOf([...Object.keys(Modals), '']).isRequired,
    onClickBack: PropTypes.func,
    onClose: PropTypes.func.isRequired,
    onOpen: PropTypes.func.isRequired,
    parentSelector: PropTypes.string.isRequired,
    shouldCloseOnOverlayClick: PropTypes.bool.isRequired,
    useModalDialog: PropTypes.bool,
};

const mapStateToProps = state => ({
    ...ModalSelectors.makeModal(state),
});

export default withRouter(connect(mapStateToProps)(ModalContainer));
